import { render, staticRenderFns } from "./Eco.vue?vue&type=template&id=1389a3ea&scoped=true"
import script from "./Eco.vue?vue&type=script&lang=js"
export * from "./Eco.vue?vue&type=script&lang=js"
import style0 from "./Eco.vue?vue&type=style&index=0&id=1389a3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389a3ea",
  null
  
)

export default component.exports